/* eslint-disable @cspell/spellchecker */
import classNames from 'classnames';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import user1Logo from '../../../assets/icons/users/user1.png';
import user10Logo from '../../../assets/icons/users/user10.png';
import user11Logo from '../../../assets/icons/users/user11.png';
import user2Logo from '../../../assets/icons/users/user2.png';
import user3Logo from '../../../assets/icons/users/user3.png';
import user4Logo from '../../../assets/icons/users/user4.png';
import user5Logo from '../../../assets/icons/users/user5.png';
import user6Logo from '../../../assets/icons/users/user6.png';
import user7Logo from '../../../assets/icons/users/user7.png';
import user8Logo from '../../../assets/icons/users/user8.png';
import user9Logo from '../../../assets/icons/users/user9.png';
import dashAiInspirationJsCodeBlock from '../../../assets/images/dash_ai_inspiration_code_block_js.png';
import dashAiInspirationPythonCodeBlock from '../../../assets/images/dash_ai_inspiration_code_block_python.png';
import dashworksLogo from '../../../assets/images/header_logo.svg';
import { Carousel } from '../../controls/Carousel/Carousel';
import { AppIcons, UIIcon } from '../../controls/ui/UIIcon/UIIcon';
import {
  Card,
  CardContent,
  CardFooter,
} from '../../shadcn/lib/components/card';

export const QAInspiration: FC<{
  shouldStream: boolean;
  onReadyToShowNext: (timer: number) => void;
  // eslint-disable-next-line max-lines-per-function
}> = ({ shouldStream, onReadyToShowNext }) => {
  const [currentChild, setCurrentChild] = useState(1);

  useEffect(() => {
    if (!shouldStream) {
      setCurrentChild(99);
      return;
    }

    const maxChildren = 2;
    let timeoutId: NodeJS.Timeout;

    if (currentChild < maxChildren) {
      timeoutId = setTimeout(() => {
        setCurrentChild((prevChild) => prevChild + 1);
      }, 800);
    }

    if (currentChild === maxChildren) {
      onReadyToShowNext(1200);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldStream, currentChild, onReadyToShowNext]);

  return (
    <div className="flex flex-col gap-4">
      {currentChild >= 1 && (
        <div
          className={classNames(
            'sm:max-w-3xl sm:mx-auto max-w-full mx-2 w-full px-4',
            { 'animate-in fade-in ease-in-out duration-400': shouldStream }
          )}
        >
          Let me share some more inspiration. Here are some ways our team uses
          Dash AI
        </div>
      )}

      {currentChild >= 2 && (
        <Carousel
          className={
            shouldStream ? 'animate-in fade-in ease-in-out duration-600' : ''
          }
          disableAutoScroll
        >
          <InspirationItem
            body={
              <>
                <div>Dear Micah,</div>
                <div>
                  Following our recent conversation on Acme AI, here's a brief
                  summary:
                </div>
                <div className="font-bold mt-1">Summary of Our Discussion:</div>
                <div>
                  During our conversation, we delved into how Acme AI can
                  revolutionize your...
                </div>
              </>
            }
            sources={['notion', 'slack', 'salesforce']}
            title="Write me a follow up email to prospect Blum"
            userLogo={user1Logo}
          />
          <InspirationItem
            body={
              <>
                <div>Dear [First Name],</div>
                <div className="mt-0.5">
                  Dashworks connects with your company's apps to help find
                  answers, write content, and complete tasks more efficiently.
                </div>
                <div className="font-bold mt-0.5">
                  Some examples of what you can ask:
                </div>
                <ul className="m-0 pl-5">
                  <li>Find the latest sales deck for...</li>
                </ul>
              </>
            }
            sources={['dropbox', 'gmail']}
            title="Help me write an email campaign introducing Dashworks"
            userLogo={user2Logo}
          />
          <InspirationItem
            body={<img src={dashAiInspirationJsCodeBlock} width="100%" />}
            sources={['github']}
            title="Give me an example of how we use react hooks in our codebase"
            userLogo={user3Logo}
          />
          <InspirationItem
            body={
              <>
                <div>
                  From our recent analysis, here these competitors are actively
                  running ads for "smart coffee":
                </div>
                <div className="mt-1">
                  <span className="font-bold">CafeGenius Brews:</span>{' '}
                  CafeGenius Brews is actively running social media campaigns
                  targeting "smart coffee" enthusiasts...
                </div>
              </>
            }
            sources={['dropbox']}
            title="Which competitors are running ads for smart coffee?"
            userLogo={user4Logo}
          />
          <InspirationItem
            body={
              <>
                <div>
                  To gain valuable insights into overall customer experience, we
                  track key KPIs such as:
                </div>
                <div className="mt-1">
                  1.{' '}
                  <span className="font-bold">Net Promoter Score (NPS):</span>{' '}
                  NPS indicates how likely our customers are to recommend our
                  products and ser...
                </div>
              </>
            }
            sources={['gdrive']}
            title="What KPIs do we track for customer health?"
            userLogo={user5Logo}
          />
          <InspirationItem
            body={
              <>
                <div className="font-bold">Overview</div>
                <div>
                  At Blum AI, we specialize in seamlessly integrating your
                  current tech stack with cutting-edge AI solutions, empowering
                  your business for enhanced efficiency and better outcomes.
                  Some key features...
                </div>
              </>
            }
            sources={['notion', 'linear', 'slack', 'gmail']}
            title="Generate a technical one-pager for Blum AI integrations"
            userLogo={user6Logo}
          />
          <InspirationItem
            body={
              <>
                1. <span className="font-bold">Seamless Collaboration:</span>{' '}
                VirtualOffice Pro offers a complete platform for seamless team
                collaboration. With integrated video conferencing, chat, and
                project management features, teams can communicate effectively.
              </>
            }
            sources={['slack', 'gdrive']}
            title="How should I position us against competition?"
            userLogo={user7Logo}
          />
          <InspirationItem
            body={
              <>
                <div>🎃 Unleash Spooktacular Efficiency with 👻 AcmeAI!</div>
                <div>
                  🔮 Cast away productivity demons 🎯 Crush your goals like a
                  wizard 💼 Streamline tasks effortlessly📈🧙‍♂
                </div>
                <div className="mt-0.5">
                  #HalloweenTech #Productivity #Efficiency
                </div>
              </>
            }
            sources={['notion', 'gmail']}
            title="Generate a Twitter post for Halloween"
            userLogo={user8Logo}
          />
          <InspirationItem
            body={
              <>
                <div>Import your custom module like this:</div>
                <img
                  className="mt-2"
                  src={dashAiInspirationPythonCodeBlock}
                  width="100%"
                />
              </>
            }
            sources={['github', 'slack']}
            title="How do we consume our requests wrapper in Python?"
            userLogo={user9Logo}
          />
          <InspirationItem
            body={
              <>
                <div className="font-bold">
                  Key Drivers of Last Quarter's Traffic Surge
                </div>
                <div>
                  Last quarter, TechSolutions Inc. employed various marketing
                  strategies to boost platform traffic:
                </div>
                <div className="mt-0.5">
                  1.{' '}
                  <span className="font-bold">
                    Content Marketing Campaigns:
                  </span>{' '}
                  Our...
                </div>
              </>
            }
            sources={['notion', 'gdrive']}
            title="What marketing initiatives drove the most traffic last quarter?"
            userLogo={user10Logo}
          />
          <InspirationItem
            body={
              <div>
                You can request time off by using the Rippling platform. Your
                time off request will need to be approved by your manager. Once
                approved, you will receive a confirmation email from Rippling
                including details like your vacation dates and...
              </div>
            }
            sources={['notion', 'gmail']}
            title="How do I request time off for a vacation?"
            userLogo={user11Logo}
          />
        </Carousel>
      )}
    </div>
  );
};

const InspirationItem: FC<{
  title: string;
  body: ReactNode;
  sources: string[];
  userLogo: string;
}> = ({ title, body, sources, userLogo }) => {
  return (
    <Card className="min-w-[344px] h-[240px] mx-0.5 mb-1 p-3 shadow-md border border-solid border-cloud-15 flex flex-col gap-4">
      <CardContent className="flex flex-col gap-3">
        <div className="flex gap-3 items-start">
          <img src={userLogo} style={{ width: 24 }} />
          <div className="text-lg leading-6 font-semibold">{title}</div>
        </div>
        <div className="flex gap-3 items-start">
          <img src={dashworksLogo} style={{ width: 24 }} />
          <div className="text-sm text-gray-50">{body}</div>
        </div>
      </CardContent>
      <CardFooter>
        {/* TODO(DAS-20523): Add white shadow effect to {body} bottom*/}
        <div className="flex">
          <div className="text-xs font-medium text-cloud-30">
            Getting answer from
          </div>
          <div className="ml-2 flex items-center gap-2">
            {sources.map((source) => (
              <UIIcon
                key={source}
                name={source as AppIcons}
                size={16}
                type="apps"
              />
            ))}
          </div>
        </div>
      </CardFooter>
    </Card>
  );
};
